import React from 'react';
import { Immutable } from 'nuclear-js';
import moment from 'moment';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import GrowthGoalsUtils from './utils';

export default CreateReactClass({
    displayName: 'UpcomingGrowthGoals',

    propTypes: {
        currentGrowthGoals: PropTypes.instanceOf(Immutable.List),
        highlightedTermNumber: PropTypes.number,
        highlightedTermEditedYn: PropTypes.bool,
        id: PropTypes.string.isRequired,
        expandedYn: PropTypes.bool.isRequired,
        toggle: PropTypes.func.isRequired,
        deleteGoal: PropTypes.func.isRequired,
        showActionPlanModal: PropTypes.func,
    },

    renderUpcomingGrowthGoalsHeader() {
        const header = (
            <div key="header-upcoming-growth-goal" className="row-goal-grid-header">
                <span key="term">Term</span>
                <span key="set-goal">Set Goal</span>
                <span key="typical-growth">Projected Growth</span>
                <span key="starting-score">Starting Score</span>
                <span key="edit-info">Set On/by</span>
                <span className="screen-only"></span>
            </div>
        );

        return header;
    },

    renderUpcomingGrowthGoals(currentGrowthGoals) {
        let goalRows = [],
            growthGoals = [];

        if (currentGrowthGoals) {
            growthGoals = currentGrowthGoals.sort((g1, g2) => g1.get('endTermNumber') - g2.get('endTermNumber'));
        }

        if (growthGoals.size > 0) {
            growthGoals.forEach((goal) => {
                const highlightRowYn = goal.get('endTermNumber') === this.props.highlightedTermNumber;
                const typicalGrowth = GrowthGoalsUtils.typicalGrowth(goal);
                const startingScore = GrowthGoalsUtils.startingScore(goal, true);
                const rowClassName = 'row-goal-grid-content row-past-goal' + (highlightRowYn ? ' highlighted' : '');

                goalRows.push(
                    <div key={goal.get('growthGoalBid')} className={rowClassName}>
                        <span className="goal-termDate">
                            {GrowthGoalsUtils.endTermName(
                                goal.get('endTermNumber'),
                                highlightRowYn,
                                this.props.highlightedTermEditedYn
                            )}
                        </span>
                        <span>{goal.get('targetScore')}</span>
                        <span className={typicalGrowth.className}>{typicalGrowth.description}</span>
                        <span className={startingScore.className}>{startingScore.description}</span>
                        <span>
                            {moment.utc(goal.get('dateEdited')).format('MM/DD/YYYY')}
                            <br />
                            {goal.get('educatorName')}
                            <br />
                            {goal.get('actionPlan') ? (
                                <a
                                    onClick={() =>
                                        this.props.showActionPlanModal(
                                            goal.get('actionPlan'),
                                            goal.get('growthGoalBid')
                                        )
                                    }
                                    key="actionPlanPastGoals"
                                    className="screen-only"
                                >
                                    Action Plan >
                                </a>
                            ) : (
                                ''
                            )}
                        </span>
                        <span
                            className="button-goal-delete screen-only"
                            onClick={() => {
                                this.props.deleteGoal(goal);
                            }}
                        >
                            Delete
                        </span>
                        <span key={'print-' + goal.get('growthGoalBid')} className="print-only action-plan">
                            {GrowthGoalsUtils.safeDecodeUri(goal.get('actionPlan', ''))}
                        </span>
                    </div>
                );
            });
        } else {
            goalRows.push(
                <div
                    key={'upcoming-goal-no-content-' + Math.floor(Math.random() * 10000)}
                    className="print-only row-goal-grid-content row-past-goal"
                >
                    There are no upcoming goals for this student.
                </div>
            );
        }

        goalRows.push(<p key="print-section-divider" className="print-only section-divider" />);

        return goalRows;
    },

    renderUpcomingGoals(currentGrowthGoals) {
        if (this.props.expandedYn) {
            return [this.renderUpcomingGrowthGoalsHeader(), this.renderUpcomingGrowthGoals(currentGrowthGoals)];
        } else {
            return null;
        }
    },

    render() {
        const hasItems = this.props.currentGrowthGoals && this.props.currentGrowthGoals.size > 0;
        return (
            <div className={hasItems ? '' : 'print-only'}>
                <div key="upcoming-growth-goal" className="goals-section" id={this.props.id}>
                    <div key="upcoming-goal-title" className="goal-title">
                        <button
                            className={
                                this.props.expandedYn
                                    ? 'goal-chevron expand-chevron-up'
                                    : 'goal-chevron expand-chevron-down'
                            }
                            onClick={this.props.toggle}
                        />
                        Upcoming Growth Goals
                    </div>

                    <div
                        key="upcoming-growth-goal-header"
                        className={
                            hasItems ? 'growth-goal-header-background' : 'print-only growth-goal-header-background'
                        }
                    />
                    <div key="upcoming-growth-goal-container" className="growth-goal container">
                        {this.renderUpcomingGoals(this.props.currentGrowthGoals)}
                    </div>
                </div>
            </div>
        );
    },
});
